import {
  isEventAttributeType,
  isGlobalAttributeType,
} from '@src/emp-3.0/components/custom-dimension/utils/checks';
import {
  EVENT_KEYS_PREFIX,
  GLOBAL_KEYS_PREFIX,
} from '@src/emp-3.0/components/custom-dimension/custom-dimension-panel/constant';

export const transformAttributeType = (status?: number) => {
  return isEventAttributeType(status)
    ? EVENT_KEYS_PREFIX
    : isGlobalAttributeType(status)
    ? GLOBAL_KEYS_PREFIX
    : '';
};
